exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../settings.css"), undefined);

// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"secondaryLabel": "CollapsibleContainer--secondaryLabel--25FMD " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../settings.css").locals["secondaryText"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/settings/common/CollapsibleContainer.css
 ** module id = 87
 ** module chunks = 0
 **/